// 이미지 인식 응답 → 프론트 동작 분기(순수 함수, 테스트 대상).
//   product(신뢰도 충분) → 기존 AI모드 검색, invoice → 감지 안내, 그 외 → 키워드 유도.
const MIN_PRODUCT_CONFIDENCE = 0.4;

export function routeRecognition(resp) {
  if (!resp || resp.success === false) {
    return {
      action: "hint",
      message: (resp && resp.error) || "이미지를 인식하지 못했습니다. 키워드로 검색해 주세요.",
    };
  }
  if (resp.type === "invoice") {
    return {
      action: "invoice",
      message: "이 이미지는 인보이스로 보입니다 — 행 추출은 곧 docuai2 연동(2차)으로 지원할 예정입니다.",
    };
  }
  const conf = typeof resp.confidence === "number" ? resp.confidence : 0;
  const query = String(resp.keywords || resp.productNameKo || "").trim();
  if (resp.type === "product" && conf >= MIN_PRODUCT_CONFIDENCE && query) {
    return { action: "search", query, label: resp.productNameKo || query };
  }
  return {
    action: "hint",
    message: "제품을 특정하기 어려워요. 키워드로 검색해 보세요.",
    label: resp.productNameKo || "",
  };
}

// 업로드 전 프리체크 — 웹표준 이미지 4종 ≤10MB (서버 가드와 일치).
export function isAcceptableImage(file) {
  if (!file) return false;
  const OK = ["image/png", "image/jpeg", "image/webp", "image/gif"];
  return OK.includes(file.type) && file.size <= 10 * 1024 * 1024;
}
